<template>

    <div class="product_page">

        <!-- Ec breadcrumb start -->
        <div class="sticky-header-next-sec  ec-breadcrumb section-space-mb">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="row ec_breadcrumb_inner">
                            <div class="col-md-6 col-sm-12">
                                <h2 class="ec-breadcrumb-title">{{ item?.name }}</h2>
                            </div>
                            <div class="col-md-6 col-sm-12">
                                <!-- ec-breadcrumb-list start -->
                                <ul class="ec-breadcrumb-list">
                                    <li class="ec-breadcrumb-item">


                                        <router-link
                                            :to="{name: 'home', params: { lang : $i18n.locale  }}">
                                            {{ $t('Home') }}
                                        </router-link>

                                    </li>
                                    <li class="ec-breadcrumb-item active" v-if="item?.section != null">
                                        <router-link
                                            :to="{name: 'products.index', params: { lang : $i18n.locale }  , query: {  'section_ids[]': item?.section?.id } }">
                                            {{ item?.section?.name }}
                                        </router-link>
                                    </li>
                                    <li class="ec-breadcrumb-item active" v-if="item?.category != null">
                                        <router-link
                                            :to="{name: 'products.index', params: { lang : $i18n.locale }  , query: {  'category_ids[]': item?.category?.id } }">
                                            {{ item?.category?.name }}
                                        </router-link>
                                    </li>
                                </ul>
                                <!-- ec-breadcrumb-list end -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Ec breadcrumb end -->

        <!-- Sart Single product -->
        <section class="ec-page-content section-space-p">
            <div class="container">
                <div class="row">
                    <div class="ec-pro-rightside ec-common-rightside col-lg-8 col-xl-9 ">

                        <!-- Single product content Start -->
                        <div class="single-pro-block">
                            <div class="single-pro-inner">
                                <div class="row">
                                    <div class="single-pro-img single-pro-img-no-sidebar col-lg-6">
                                        <div class="single-product-scroll">

                                            <div class="single-product-cover" style="display: none">

                                                <div
                                                    class="single-slide zoom-image-hover d-flex justify-content-center  cover-image"
                                                    v-if="item?.image !=null">
                                                    <img class="img-responsive" :src="item?.image"
                                                         alt="...">
                                                </div>

                                                <div
                                                    class="single-slide zoom-image-hover d-flex justify-content-center cover-image"
                                                    v-for="img in item?.images">
                                                    <img class="img-responsive" :src="img?.path_url"
                                                         alt="...">
                                                </div>

                                            </div>

                                            <div class="single-nav-thumb" style="display: none">

                                                <div class="single-slide d-flex justify-content-center"
                                                     v-if="item?.image != null">
                                                    <img class="img-responsive" :src="item?.image"
                                                         alt="...">
                                                </div>

                                                <div class="single-slide d-flex justify-content-center"
                                                     v-for="img in item?.images">
                                                    <img class="img-responsive" :src="img?.path_url"
                                                         alt="...">
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="single-pro-desc single-pro-desc-no-sidebar col-lg-6">
                                        <div class="single-pro-content">
                                            <h5 class="ec-single-title">{{ item?.name }}</h5>

                                            <div class="ec-single-rating-wrap">
                                                <div class="ec-single-rating">

                                                    <i v-for="(star, index) in ( item?.avg_rating ?? 0 )" :key="index"
                                                       class="ecicon eci-star fill"></i>

                                                    <i v-for="(star, index) in 5 - ( item?.avg_rating ?? 0)" :key="index"
                                                       class="ecicon eci-star-o"></i>

                                                </div>
                                                <!--                                                -->
                                                <!--                                                <span class="ec-read-review"><a href="#ec-spt-nav-review">Be the first to-->
                                                <!--                                                    review this product</a></span>-->
                                            </div>

                                            <div class="ec-single-desc" v-if="item?.description != null">
                                                {{ item?.description }}
                                            </div>

                                            <!--                                            <div class="ec-single-sales">-->
                                            <!--                                                <div class="ec-single-sales-inner">-->
                                            <!--                                                    <div class="ec-single-sales-title">sales accelerators</div>-->
                                            <!--                                                    <div class="ec-single-sales-visitor">real time <span>24</span> visitor-->
                                            <!--                                                        right now!</div>-->
                                            <!--                                                    <div class="ec-single-sales-progress">-->
                                            <!--                                                    <span class="ec-single-progress-desc">Hurry up!left 29 in-->
                                            <!--                                                        stock</span>-->
                                            <!--                                                        <span class="ec-single-progressbar"></span>-->
                                            <!--                                                    </div>-->
                                            <!--                                                    <div class="ec-single-sales-countdown">-->
                                            <!--                                                        <div class="ec-single-countdown"><span-->
                                            <!--                                                            id="ec-single-countdown"></span></div>-->
                                            <!--                                                        <div class="ec-single-count-desc">Time is Running Out!</div>-->
                                            <!--                                                    </div>-->
                                            <!--                                                </div>-->
                                            <!--                                            </div>-->
                                            <div class="ec-single-price-stoke">
                                                <div class="ec-single-price">
                                                    <span class="ec-single-ps-title">السعر</span>
                                                    <span class="new-price" v-if="item?.old_price == null">
                                                        {{ item?.price_tax }} {{ $t('SAR') }}
                                                    </span>
                                                    <span class="new-price" v-if="item?.old_price != null">

<!--                                                        <span class="text-danger">{{ item?.discount }}</span>-->
                                                         <del v-if="item?.old_price != null" class="text-muted">{{ item?.old_price }} {{ $t('SAR') }}</del> {{ item?.price_tax }} {{ $t('SAR') }}

                                                    </span>
<!--                                                    <div v-if="item?.old_price != null">السعر قبل التخفيض-->
<!--                                                        <del>{{ item?.old_price }} {{ $t('SAR') }}</del>-->
<!--                                                    </div>-->
                                                  <small class="text-muted mt-2">شامل ضريبة القيمة المضافة.</small>
                                                </div>
                                                <div class="ec-single-stoke">
                                                    <span
                                                        class="ec-single-ps-title text-muted">متاح للشراء</span>
                                                    <span class="ec-single-sku text-danger">
                                                        <i class="fa-solid fa-fire"></i>
                                                        تم شراءه {{ item?.order_items_count }} مرة
                                                    </span>
                                                </div>
                                            </div>


                                            <!--                                            <div class="ec-pro-variation">-->
                                            <!--                                                <div class="ec-pro-variation-inner ec-pro-variation-size">-->
                                            <!--                                                    <span>SIZE</span>-->
                                            <!--                                                    <div class="ec-pro-variation-content">-->
                                            <!--                                                        <ul>-->
                                            <!--                                                            <li class="active"><span>7</span></li>-->
                                            <!--                                                            <li><span>8</span></li>-->
                                            <!--                                                            <li><span>9</span></li>-->
                                            <!--                                                        </ul>-->
                                            <!--                                                    </div>-->
                                            <!--                                                </div>-->
                                            <!--                                                <div class="ec-pro-variation-inner ec-pro-variation-color">-->
                                            <!--                                                    <span>Color</span>-->
                                            <!--                                                    <div class="ec-pro-variation-content">-->
                                            <!--                                                        <ul>-->
                                            <!--                                                            <li class="active"><span-->
                                            <!--                                                                style="background-color:#23839c;"></span></li>-->
                                            <!--                                                            <li><span style="background-color:#000;"></span></li>-->
                                            <!--                                                        </ul>-->
                                            <!--                                                    </div>-->
                                            <!--                                                </div>-->
                                            <!--                                            </div>-->
                                            <div class="ec-single-qty">


                                                <CartButton :product="item" v-if="item?.id != null" :type="'button-qty-input'"></CartButton>


                                                <!--                                                <div class="ec-single-wishlist">-->
                                                <!--                                                    <a class="ec-btn-group wishlist" title="Wishlist">-->
                                                <!--                                                        <i-->
                                                <!--                                                        class="fi-rr-heart"></i>-->
                                                <!--                                                    </a>-->
                                                <!--                                                </div>-->
                                                <favoriteIcon
                                                    :item="item" @update:item="item.favorite = $event.favorite"
                                                    :theme="'ec-single-wishlist'"
                                                ></favoriteIcon>

                                                <!--                                                <div class="ec-single-quickview">-->
                                                <!--                                                    <a href="#" class="ec-btn-group quickview" data-link-action="quickview"-->
                                                <!--                                                       title="Quick view" data-bs-toggle="modal"-->
                                                <!--                                                       data-bs-target="#ec_quickview_modal"><i class="fi-rr-eye"></i></a>-->
                                                <!--                                                </div>-->
                                            </div>

                                            <div class="paymnet-option">
                                                <p class="text-muted">
                                                    {{ $t('Your financial transactions are safe') }}
                                                </p>
                                                <img src="/images/more/telr.png"
                                                     class="blur-up lazyload mw-100" alt="" style="width: 300px">
                                            </div>
                                            <!--                                            <div class="ec-single-social">-->
                                            <!--                                                <ul class="mb-0">-->
                                            <!--                                                    <li class="list-inline-item facebook"><a href="#"><i-->
                                            <!--                                                        class="ecicon eci-facebook"></i></a></li>-->
                                            <!--                                                    <li class="list-inline-item twitter"><a href="#"><i-->
                                            <!--                                                        class="ecicon eci-twitter"></i></a></li>-->
                                            <!--                                                    <li class="list-inline-item instagram"><a href="#"><i-->
                                            <!--                                                        class="ecicon eci-instagram"></i></a></li>-->
                                            <!--                                                    <li class="list-inline-item youtube-play"><a href="#"><i-->
                                            <!--                                                        class="ecicon eci-youtube-play"></i></a></li>-->
                                            <!--                                                    <li class="list-inline-item behance"><a href="#"><i-->
                                            <!--                                                        class="ecicon eci-behance"></i></a></li>-->
                                            <!--                                                    <li class="list-inline-item whatsapp"><a href="#"><i-->
                                            <!--                                                        class="ecicon eci-whatsapp"></i></a></li>-->
                                            <!--                                                    <li class="list-inline-item plus"><a href="#"><i-->
                                            <!--                                                        class="ecicon eci-plus"></i></a></li>-->
                                            <!--                                                </ul>-->
                                            <!--                                            </div>-->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--Single product content End -->

                        <!-- Single product tab start -->
                        <div class="ec-single-pro-tab mb-3">
                            <div class="ec-single-pro-tab-wrapper">
                                <div class="ec-single-pro-tab-nav">
                                    <ul class="nav nav-tabs">
                                        <li class="nav-item">
                                            <a class="nav-link ms-2 active" data-bs-toggle="tab"
                                               data-bs-target="#ec-spt-nav-details" role="tablist"> {{
                                                    $t('Description')
                                                }} </a>
                                            <a class="nav-link ms-2" data-bs-toggle="tab"
                                               data-bs-target="#ec-spt-nav-reviews" role="tablist"> {{
                                                    $t('Reviews')
                                                }} </a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="tab-content  ec-single-pro-tab-content">
                                    <div id="ec-spt-nav-details" class="tab-pane fade show active">
                                        <div class="ec-single-pro-tab-desc">
                                            <div v-html="item.content "></div>
                                        </div>
                                    </div>
                                    <div id="ec-spt-nav-reviews" class="tab-pane fade  ">
                                        <div class="ec-single-pro-tab-desc">
                                            <product-reviews :product_id="item?.id" v-if="item?.id > 0 "></product-reviews>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- product details description area end -->


                    </div>
                    <div class="col-lg-4 col-xl-3 ">
                        <div class="ec-sidebar-slider">
                            <div class="ec-sb-slider-title">{{ $t('Best seller') }}</div>
                            <div class="ec-sb-pro-sl">


                                <div v-for="product in best_selling">
                                    <div class="ec-sb-pro-sl-item">

                                        <router-link
                                            :to="{name: 'products.show', params: { id: product.id , lang : $i18n.locale  }}"
                                            class="sidekka_pro_img">

                                            <img class="pic-1 rounded-3"
                                                 :src="product.image ?? '/images/spices-jar.jpeg'"
                                                 alt="" width="80"/>
                                            <!--                                                <img class="pic-2" :src="product.image ?? '/images/spices-jar.jpeg'"-->
                                            <!--                                                     alt="" />-->
                                        </router-link>
                                        <div class="ec-pro-content">
                                            <h5 class="ec-pro-title">

                                                <router-link
                                                    :to="{name: 'products.show', params: { id: product.id , lang : $i18n.locale  }}">
                                                    {{ product?.name }}
                                                </router-link>
                                            </h5>
                                            <div class="ec-pro-rating">

                                                <i v-for="(star, index) in ( product?.avg_rating ?? 0 )" :key="index"
                                                   class="ecicon eci-star fill"></i>

                                                <i v-for="(star, index) in 5 - ( product?.avg_rating ?? 0)" :key="index"
                                                   class="ecicon eci-star-o"></i>

                                            </div>
                                            <span class="ec-price">
<!--                                                <span class="old-price">$100.00</span>-->
                                                <span class="new-price">{{ product?.price_tax }}  {{ $t('SAR') }}</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- End Single product -->

        <!-- START Product Transparent Style -->
        <section class="sec-tp el-prod section-space-p">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 text-center">
                        <div class="section-title">
                            <h2 class="ec-bg-title">{{ $t('Related Products') }}</h2>
                            <!--                        <h2 class="ec-title">Style 4</h2>-->
                            <!--                        <p class="sub-title">Browse The Collection of Top Categories</p>-->
                        </div>
                    </div>
                </div>
                <div class="row">

                    <div class="col-lg-3 col-md-6 col-sm-6"
                         v-for="product in related" :key="product.id">
                        <!-- START single card -->
                        <div class="ec-product-tp">
                            <div class="ec-product-image">

                                <router-link
                                    :to="{name: 'products.show', params: { id: product.id , lang : $i18n.locale  }}"
                                    class="  d-flex justify-content-center">
                                    <img :src="product.image ?? '/images/spices-jar.jpeg'"
                                         class="img-center" alt="">
                                </router-link>

                                <!--                            <span class="ec-product-ribbon">New</span>-->
                                <!--                            <div class="ec-link-icon">-->
                                <!--                                <a href="#" data-tip="Add to Wishlist"><i class="fi-rr-heart"></i></a>-->
                                <!--                                <a href="#" data-tip="Compare"><i class="fi fi-rr-arrows-repeat"></i></a>-->
                                <!--                                <a href="#" data-tip="Quick View"><i class="fi-rr-eye"></i></a>-->
                                <!--                            </div>-->
                            </div>
                            <div class="ec-product-body">
                                <h3 class="ec-title">
                                    <router-link
                                        :to="{name: 'products.show', params: { id: product.id , lang : $i18n.locale  }}"
                                        @click="scrollToTop">
                                        {{ product?.name }}
                                    </router-link>
                                </h3>
                                <p class="ec-description">
                                    {{ product?.description }}
                                </p>

                                <ul class="ec-rating">

                                    <li v-for="(star, index) in ( product?.avg_rating ?? 0 )" :key="index"
                                        class="ecicon eci-star fill"></li>

                                    <li v-for="(star, index) in 5 - ( product?.avg_rating ?? 0)" :key="index"
                                        class="ecicon eci-star-o"></li>

                                </ul>

                                <div class="ec-price mb-2">
                                    {{ product?.price_tax }} {{ $t('SAR') }}
                                </div>

                                <CartButton :product="product" v-if="product?.id != null"  :type="'outline-link'"></CartButton>

                            </div>

                        </div>
                        <!-- START single card -->
                    </div>

                </div>
            </div>
        </section>
        <!--/END Product Default Style -->

    </div>

</template>

<script>
import {useToast} from "vue-toastification";
import CartButton from "../cart_item/CartButton.vue";
import {Head, useHead} from "@vueuse/head"
import favoriteIcon from "./favorite-icon.vue";
import ProductReviews from "../review/index.vue";

const toast = useToast();

export default {
    components: {
        ProductReviews,
        CartButton,
        favoriteIcon,
    },
    data() {
        return {
            item: [],
            trending: [],
            related: [],
            best_selling: []
        }
    },
    async created() {

        const id = toast.info(this.$t('Getting content ...'), {icon: 'fa-solid fa-download'});

        await axios.get(`products/${this.$route.params.id}`, {}).then(response => {
            this.item = response.data.data;
            // this.trending = response.data.trending;
            this.related = response.data.related;
            this.best_selling = response.data.best_selling;
            toast.dismiss(id);
        }, response => {
            if (response.response.status === 404) {
                this.$router.push({name: 'home', params: {lang: this.$i18n.locale}});
            }
            toast.dismiss(id);
        });

        this.playSlider();

        useHead({
            title: this.item?.name,
        })
    },
    methods: {
        scrollToTop() {
            window.scrollTo(0,0);
        },
        playSlider() {

            setTimeout(function () {

                console.log('playSlider');
                /*----------------------------- single product Slider  ------------------------------ */
                $('.single-product-cover').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    fade: false,
                    asNavFor: '.single-nav-thumb',
                });

                $('.single-nav-thumb').slick({
                    slidesToShow: 6,
                    slidesToScroll: 1,
                    asNavFor: '.single-product-cover',
                    dots: false,
                    arrows: true,
                    focusOnSelect: true,
                });


                $(' .ec-sb-pro-sl').slick({
                    rows: 4,
                    dots: false,
                    arrows: true,
                    infinite: true,
                    speed: 500,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                    autoplaySpeed: 8000,
                    responsive: [
                        {
                            breakpoint: 992,
                            settings: {
                                rows: 4,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                dots: false
                            }
                        },
                        {
                            breakpoint: 479,
                            settings: {
                                rows: 4,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                dots: false
                            }
                        }
                    ]
                });

                $('.single-product-cover').show();
                $('.single-nav-thumb').show();

            }, 10);
        }
    }
}
</script>
